
import types from './types';

const handleRequestError = (state, action) => ({
    ...state,
    isLoading: false,
    errors: [action.payload]
});

export const checkRegistration = {
    [types.CHECK_REGISTRATION.REQUEST]: state => ({
        ...state,
        isLoading: true
    }),

    [types.CHECK_REGISTRATION.SUCCESS]: (state, { payload: { registrationPossible, clientChannelId } }) => ({
        ...state,
        registrationPossible,
        clientChannelId,
        isLoading: false,
        registrationErrors: []
    }),

    [types.CHECK_REGISTRATION.ERROR]: (state, action) => ({
        ...state,
        isLoading: false,
        registrationErrors: [action.payload]
    })
};

export const checkOptedIn = {
    [types.CHECK_OPTED_IN.REQUEST]: state => ({
        ...state,
        isLoading: true
    }),

    [types.CHECK_OPTED_IN.SUCCESS]: (state, action) => ({
        ...state,
        isOptedIn: action.payload,
        isLoading: false,
        errors: []
    }),

    [types.CHECK_OPTED_IN.ERROR]: handleRequestError
};

export const checkSupport = {
    [types.CHECK_SUPPORT.REQUEST]: state => ({
        ...state,
        isLoading: true
    }),
    [types.CHECK_SUPPORT.SUCCESS]: (state, action) => ({
        ...state,
        isSupported: action.payload,
        isLoading: false,
        errors: []
    }),

    [types.CHECK_SUPPORT.ERROR]: handleRequestError
};

export const checkPermission = {
    [types.CHECK_PERMISSION.REQUEST]: state => ({
        ...state,
        isLoading: true
    }),

    [types.CHECK_PERMISSION.SUCCESS]: (state, action) => ({
        ...state,
        permissionStatus: action.payload,
        isLoading: false,
        errors: []
    }),

    [types.CHECK_PERMISSION.ERROR]: handleRequestError
};
